import React from "react";
import PropTypes from "prop-types";
import { Grid, Paper, Typography } from "@material-ui/core";
import { toCamelCase } from "utils/Utils";

const styles = {
  card: {
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    padding: 24,
    marginBottom: 24,
    boxShadow: "none",
  },
  title: {
    fontSize: 22,
    fontWeight: 600,
    color: "#1E3A5F",
    marginBottom: 24,
  },
  referenceCard: {
    border: "1px solid #EDF2F7",
    borderRadius: 10,
    padding: 20,
    marginBottom: 20,
    background: "#FAFBFC",
  },
  referenceTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: "#1E3A5F",
    marginBottom: 18,
  },
  label: {
    fontSize: 13,
    color: "#6B7280",
    marginBottom: 6,
    fontWeight: 500,
  },
  value: {
    fontSize: 15,
    fontWeight: 600,
    color: "#1F2937",
    wordBreak: "break-word",
  },
  item: {
    marginBottom: 18,
  },
};

const Field = ({ label, value }) => (
  <Grid item xs={12} sm={6} md={4}>
    <div style={styles.item}>
      <Typography style={styles.label}>
        {label}
      </Typography>

      <Typography style={styles.value}>
        {value || "NA"}
      </Typography>
    </div>
  </Grid>
);

const ReferenceReview = ({ referenceDetails }) => {
  return (
    <Paper style={styles.card}>
      <Typography style={styles.title}>
        Reference Details
      </Typography>

      {referenceDetails?.map((item, index) => (
        <Paper
          key={index}
          elevation={0}
          style={styles.referenceCard}
        >
          <Typography style={styles.referenceTitle}>
            Reference {index + 1}
          </Typography>

          <Grid container spacing={2}>
            <Field
              label="Name"
              value={toCamelCase(item?.referalName)}
            />

            <Field
              label="Relation"
              value={toCamelCase(item?.referalRelation)}
            />

            <Field
              label="Mobile Number"
              value={item?.phoneNumber}
            />
          </Grid>
        </Paper>
      ))}
    </Paper>
  );
};

Field.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
};

ReferenceReview.propTypes = {
  referenceDetails: PropTypes.arrayOf(
    PropTypes.shape({
      referalName: PropTypes.string,
      referalRelation: PropTypes.string,
      phoneNumber: PropTypes.string,
    })
  ),
};

export default ReferenceReview;